import { parseDate } from './utils'

export default class PodStatus {
	static fromJSON(json) {
		return new PodStatus(json.pod, json.phase)
			.withStatus(json.hasErrors, json.hasWarns)
			.withDate(json.created)
			.withService(json.pod)
			.withTimeouts(json.withTimeouts)
	}

	constructor(pod, phase) {
		this.pod = pod
		this.phase = phase
	}

	withDate(timeStampStr) {
		if (timeStampStr) {
			this.date = parseDate(+timeStampStr * 1000, true)
		} else {
			this.date = {}
		}
		return this
	}

	withStatus(hasErrors, hasWarns) {
		this.hasErrors = hasErrors
		this.hasWarns = hasWarns

		return this
	}

	withService(podName) {
		if (podName.match(/-\d+$/)) {
			this.service = podName.match(/^[^-]+(?:-[^-]+)*[^-]/)[0]
		} else {
			const serviceName = podName
				.match(/^[a-zA-Z-]+/)[0]
				.replace(/-[a-zA-Z0-9]+$/, '')

			this.service = serviceName.endsWith('-')
				? serviceName.slice(0, -1)
				: serviceName
		}

		return this
	}

	withTimeouts(withTimeouts) {
		this.withTimeouts = withTimeouts ?? false

		return this
	}
}
